<template>
  <v-list class="mb-12">
    <v-list-item-group color="primary">
      <template v-for="item in items">
        <template v-if="item.type === 'group'">
          <template v-if="(!item.requiresAuth || user)
            && (item.invalid_domains.length === 0 || (user && item.invalid_domains.indexOf(user.domain) < 0))
            && (!item.role || (user && item.role === user.role))">
            <v-list-group
              :key="item.title"
              :prepend-icon="item.icon"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">{{ $t("message.navigation." + item.title) }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template v-for="sub_item in item.sub_items">
                <template v-if="(sub_item.invalid_domains.length === 0 || (user && sub_item.invalid_domains.indexOf(user.domain) < 0))
                  && (!sub_item.role || (user && sub_item.role === user.role))">
                  <template v-if="!sub_item.external">
                    <v-list-item :to="sub_item.route" :disabled="$route.path === sub_item.route" :key="sub_item.route">
                      <v-list-item-action v-if="sub_item.icon">
                        <v-icon>{{ sub_item.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title class="text-wrap">{{ $t("message.navigation." + sub_item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <v-list-item :disabled="$route.path === sub_item.route" :key="sub_item.route">
                      <template v-slot:default="{ toggle }">
                        <v-list-item-action v-if="sub_item.icon" @click="popup(sub_item.route, toggle)">
                          <v-icon>{{ sub_item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content @click="popup(sub_item.route, toggle)">
                          <v-list-item-title class="text-wrap">
                            {{ $t("message.navigation." + sub_item.title) }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </template>
              </template>
            </v-list-group>
          </template>
        </template>

        <template v-else-if="item.type === 'divider'">
          <v-divider :key="item.type"></v-divider>
        </template>

        <template v-else-if="(!item.requiresAuth || user)
          && (item.invalid_domains.length === 0 || (user && item.invalid_domains.indexOf(user.domain) < 0))
          && (!item.role || item.role === user.role)">
          <template v-if="!item.external">
            <v-list-item :to="item.route" :disabled="$route.path === item.route" :key="item.route">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">{{ $t("message.navigation." + item.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-item :disabled="$route.path === item.route" :key="item.route">
              <template v-slot:default="{ toggle }">
                <v-list-item-action @click="popup(item.route, toggle)">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content @click="popup(item.route, toggle)">
                  <v-list-item-title class="text-wrap">
                    {{ $t("message.navigation." + item.title) }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </template>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'navigation',
  data: function(){
    return {
      module_id: "51"
    }
  },
  methods: {
    popup: function(url, toggle){
      window.open(url, '_target');
      toggle();
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    items: function(){
      return [
        {
          "type": "single",
          "route": "/",
          "icon": "mdi-home",
          "title": "home",
          "requiresAuth": false,
          "invalid_domains": []
        },
        {
          "type": "single",
          "route": "/translate",
          "icon": "mdi-translate",
          "title": "translate",
          "requiresAuth": true,
          "invalid_domains": []
        },
        {
          "type": "single",
          "route": "/train",
          "icon": "mdi-brain",
          "title": "train",
          "requiresAuth": true,
          "invalid_domains": ['the-reading']
        },
        {
          "type": "single",
          "route": "/similarity",
          "icon": "mdi-gauge",
          "title": "similarity",
          "requiresAuth": true,
          "invalid_domains": ['the-reading']
        },
        {
          "type": "single",
          "route": "/editor",
          "icon": "mdi-book-open",
          "title": "editor",
          "requiresAuth": true,
          "invalid_domains": ['the-reading']
        },
        {
          "type": "group",
          "icon": "mdi-file",
          "title": "user_resource",
          "requiresAuth": true,
          "invalid_domains": [],
          "sub_items": [
            {
              "route": "/user",
              "title": "user",
              "invalid_domains": []
            },
            {
              "route": "/file",
              "title": "file",
              "invalid_domains": []
            },
            {
              "route": "/job",
              "title": "job",
              "invalid_domains": []
            },
            {
              "route": "/model",
              "title": "model",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/corpus",
              "title": "corpus",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/term",
              "title": "term",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/translation_preset",
              "title": "translation_preset",
              "invalid_domains": []
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "type": "group",
          "icon": "mdi-account-group",
          "title": "group_resource",
          "requiresAuth": true,
          "invalid_domains": [],
          "role": "group_manager",
          "sub_items": [
            {
              "route": "/group/group",
              "title": "group",
              "invalid_domains": []
            },
            {
              "route": "/group/user",
              "title": "user",
              "invalid_domains": []
            },
            {
              "route": "/group/file",
              "title": "file",
              "invalid_domains": []
            },
            {
              "route": "/group/job",
              "title": "job",
              "invalid_domains": []
            },
            {
              "route": "/group/model",
              "title": "model",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/group/corpus",
              "title": "corpus",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/group/term",
              "title": "term",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/group/translation_preset",
              "title": "translation_preset",
              "invalid_domains": []
            }
          ]
        },
        {
          "type": "group",
          "icon": "mdi-domain",
          "title": "organization_resource",
          "requiresAuth": true,
          "invalid_domains": [],
          "role": "organization_manager",
          "sub_items": [
            {
              "route": "/organization/organization",
              "title": "organization",
              "invalid_domains": []
            },
            {
              "route": "/organization/group",
              "title": "group",
              "invalid_domains": []
            },
            {
              "route": "/organization/user",
              "title": "user",
              "invalid_domains": []
            },
            {
              "route": "/organization/file",
              "title": "file",
              "invalid_domains": []
            },
            {
              "route": "/organization/job",
              "title": "job",
              "invalid_domains": []
            },
            {
              "route": "/organization/model",
              "title": "model",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/organization/corpus",
              "title": "corpus",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/organization/term",
              "title": "term",
              "invalid_domains": ['the-reading']
            },
            {
              "route": "/organization/translation_preset",
              "title": "translation_preset",
              "invalid_domains": []
            }
          ]
        },
        {
          "type": "group",
          "icon": "mdi-account-circle",
          "title": "account",
          "requiresAuth": true,
          "invalid_domains": [],
          "sub_items": [
            {
              "route": "/profile",
              "title": "profile",
              "invalid_domains": []
            },
            /*{
              "route": "/notification",
              "title": "notification",
              "invalid_domains": []
            },*/
            {
              "route": "/preference",
              "title": "preference",
              "invalid_domains": []
            }
          ]
        },
        {
          "type": "group",
          "icon": "mdi-information",
          "title": "information",
          "requiresAuth": false,
          "invalid_domains": [],
          "sub_items": [
            {
              "route": "/version",
              "title": "version",
              "invalid_domains": []
            },
            {
              "route": "https://www.rozetta.jp/lp/t3mt/about/terms_"+ this.$i18n.locale +".pdf",
              "title": "item_terms",
              "invalid_domains": [],
              "external": true
            },
            {
              "route": "https://www.rozetta.jp/privacy"+ (this.$i18n.locale === "en" ? "_" + this.$i18n.locale : "") +".pdf",
              "title": "item_privacy",
              "invalid_domains": [],
              "external": true
            },
            {
              "route": "https://www.rozetta.jp/lp/t3mt/about/notation_"+ this.$i18n.locale +".pdf",
              "title": "item_tokusho",
              "invalid_domains": [],
              "external": true
            },{
              "route": "https://www.rozetta.jp/lp/t3mt/about/security_"+ this.$i18n.locale +".pdf",
              "title": "item_security",
              "invalid_domains": [],
              "external": true
            },
          ]
        },
        {
          "type": "group",
          "icon": "mdi-help",
          "title": "support",
          "requiresAuth": true,
          "invalid_domains": [],
          "sub_items": [
            {
              "route": "https://www.rozetta.jp/lp/t3mt/manual/" + this.$i18n.locale + "/user/" + this.$store.getters.domain + "/top.html",
              "title": "user_operation",
              "invalid_domains": [],
              "external": true
            },
            {
              "route": "https://www.rozetta.jp/lp/t3mt/manual/" + this.$i18n.locale + "/editor/t-3mt/top.html",
              "title": "editor_operation",
              "invalid_domains": ['the-reading'],
              "external": true
            },
            {
              "route": "https://www.rozetta.jp/lp/t3mt/manual/" + this.$i18n.locale + "/manager/t-3mt/top.html",
              "title": "manager_operation",
              "invalid_domains": [],
              "external": true,
              "role": "organization_manager"
            },
            {
              "route": "https://www.rozetta.jp/lp/t3mt/manual/" + this.$i18n.locale + "/manager/t-3mt/top.html",
              "title": "manager_operation",
              "invalid_domains": [],
              "external": true,
              "role": "group_manager",
            },
            {
              "route": "/v" + this.$store.getters.api_version + "/manual/" + this.$i18n.locale + "/api/index.html",
              "title": "api",
              "invalid_domains": [],
              "external": true
            },
            {
              "route": "https://www.rozetta.jp/lp/thereading/instruction/",
              "title": "movie",
              "requiresAuth": true,
              "invalid_domains": ["t-3mt"],
              "external": true
            },
          ]
        }
      ];
    }
  }
}
</script>
